import { FC, Fragment } from "react";
import { Restaurant } from "../Restaurant/Restaurant";

export const Footer: FC = () => {
  const date = new Date();

  return (
    <Fragment>
      <div className="footer-widget-area">
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <div className="footer-info left">
                Date:
                <br />
                Thursday, 29 May 2025
              </div>
            </div>

            <div className="col-md-4">
              <div className="footer-logo">
                Andrii
                <br />
                <small>&</small>
                <br />
                Anastasiia
              </div>
            </div>

            <div className="col-md-4">
              <div className="footer-info right">
                <span>
                  Location:
                  <br />
                  <Restaurant textDecoration='none' />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="copyright">
        <div className="container">
          <div className="row">
            <div className="col-sm-12" id="copyright">
              &copy; {date.getFullYear()} All Rights Reserved.
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
